import { Dialog, Flex, Button } from '@radix-ui/themes';
import { useConfirmDialog } from '../../contexts/confirmDialog';
import { useEffect, useState } from 'react';

export const ConfirmDialog = ({ title = 'Confirm Action' }) => {
  const { isOpen, message, handleConfirm, handleCancel, options } = useConfirmDialog();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(isOpen);
  }, [isOpen]);

  const handleClose = () => {
    setOpen(false);
    handleCancel();
  };

  return (
    <Dialog.Root open={open} onOpenChange={setOpen}>
      <Dialog.Content>
        <Dialog.Title size="3">{options.title}</Dialog.Title>
        <Dialog.Description>{message}</Dialog.Description>

        <Flex gap="3" mt="4" justify="end">
          <Dialog.Close>
            <Button variant="soft" color="gray" onClick={handleClose}>
              {options.cancelText}
            </Button>
          </Dialog.Close>
          <Dialog.Close>
            <Button color={options.confirmColor || 'accent'} onClick={handleConfirm}>{options.confirmText}</Button>
          </Dialog.Close>
        </Flex>
      </Dialog.Content>
    </Dialog.Root>
  );
};
